/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { productCategoryControllerCreate } from '../fn/product-category/product-category-controller-create';
import { ProductCategoryControllerCreate$Params } from '../fn/product-category/product-category-controller-create';
import { productCategoryControllerDelete } from '../fn/product-category/product-category-controller-delete';
import { ProductCategoryControllerDelete$Params } from '../fn/product-category/product-category-controller-delete';
import { productCategoryControllerGetAll } from '../fn/product-category/product-category-controller-get-all';
import { ProductCategoryControllerGetAll$Params } from '../fn/product-category/product-category-controller-get-all';
import { productCategoryControllerGetAllFlattened } from '../fn/product-category/product-category-controller-get-all-flattened';
import { ProductCategoryControllerGetAllFlattened$Params } from '../fn/product-category/product-category-controller-get-all-flattened';
import { productCategoryControllerGetOne } from '../fn/product-category/product-category-controller-get-one';
import { ProductCategoryControllerGetOne$Params } from '../fn/product-category/product-category-controller-get-one';
import { productCategoryControllerGetOneWithChildren } from '../fn/product-category/product-category-controller-get-one-with-children';
import { ProductCategoryControllerGetOneWithChildren$Params } from '../fn/product-category/product-category-controller-get-one-with-children';
import { productCategoryControllerSaveCustomFields } from '../fn/product-category/product-category-controller-save-custom-fields';
import { ProductCategoryControllerSaveCustomFields$Params } from '../fn/product-category/product-category-controller-save-custom-fields';
import { productCategoryControllerUpdate } from '../fn/product-category/product-category-controller-update';
import { ProductCategoryControllerUpdate$Params } from '../fn/product-category/product-category-controller-update';
import { ProductCategoryItem } from '../models/product-category-item';
import { ProductCategoryResponse } from '../models/product-category-response';

@Injectable({ providedIn: 'root' })
export class ProductCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productCategoryControllerGetAll()` */
  static readonly ProductCategoryControllerGetAllPath = '/product/product-category';

  /**
   * Restituisce l'elenco delle categorie di prodotti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetAll$Response(params?: ProductCategoryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryResponse;
}>> {
    return productCategoryControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle categorie di prodotti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetAll(params?: ProductCategoryControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryResponse;
}> {
    return this.productCategoryControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryResponse;
}>): BaseResponse & {
'data'?: ProductCategoryResponse;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerCreate()` */
  static readonly ProductCategoryControllerCreatePath = '/product/product-category';

  /**
   * Crea una categoria di prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerCreate$Response(params: ProductCategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una categoria di prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerCreate(params: ProductCategoryControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerGetAllFlattened()` */
  static readonly ProductCategoryControllerGetAllFlattenedPath = '/product/product-category/flatten';

  /**
   * Restituisce l'elenco delle categorie di prodotti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerGetAllFlattened()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetAllFlattened$Response(params?: ProductCategoryControllerGetAllFlattened$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryResponse;
}>> {
    return productCategoryControllerGetAllFlattened(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle categorie di prodotti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerGetAllFlattened$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetAllFlattened(params?: ProductCategoryControllerGetAllFlattened$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryResponse;
}> {
    return this.productCategoryControllerGetAllFlattened$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryResponse;
}>): BaseResponse & {
'data'?: ProductCategoryResponse;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerGetOne()` */
  static readonly ProductCategoryControllerGetOnePath = '/product/product-category/{id}';

  /**
   * Restituisce una categoria di prodotti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetOne$Response(params: ProductCategoryControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una categoria di prodotti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetOne(params: ProductCategoryControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerDelete()` */
  static readonly ProductCategoryControllerDeletePath = '/product/product-category/{id}';

  /**
   * Elimina una categoria e tutte le sottocategorie.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerDelete$Response(params: ProductCategoryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una categoria e tutte le sottocategorie.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerDelete(params: ProductCategoryControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerUpdate()` */
  static readonly ProductCategoryControllerUpdatePath = '/product/product-category/{id}';

  /**
   * Modifica il nome di una categoria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdate$Response(params: ProductCategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica il nome di una categoria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdate(params: ProductCategoryControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerGetOneWithChildren()` */
  static readonly ProductCategoryControllerGetOneWithChildrenPath = '/product/product-category/{id}/detail';

  /**
   * Restituisce una categoria di prodotti e le sottocategorie.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerGetOneWithChildren()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetOneWithChildren$Response(params: ProductCategoryControllerGetOneWithChildren$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerGetOneWithChildren(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una categoria di prodotti e le sottocategorie.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerGetOneWithChildren$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerGetOneWithChildren(params: ProductCategoryControllerGetOneWithChildren$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerGetOneWithChildren$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerSaveCustomFields()` */
  static readonly ProductCategoryControllerSaveCustomFieldsPath = '/product/product-category/{id}/custom-fields';

  /**
   * Imposta i campi personalizzati di una c.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerSaveCustomFields()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerSaveCustomFields$Response(params: ProductCategoryControllerSaveCustomFields$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>> {
    return productCategoryControllerSaveCustomFields(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta i campi personalizzati di una c.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerSaveCustomFields$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerSaveCustomFields(params: ProductCategoryControllerSaveCustomFields$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProductCategoryItem;
}> {
    return this.productCategoryControllerSaveCustomFields$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryItem;
}>): BaseResponse & {
'data'?: ProductCategoryItem;
} => r.body)
    );
  }

}
